<div class="quick-apply-container">
  <app-talent-happy-path-header
    [headerText]="postingInfo ? postingInfo.jobTitle : 'talent-happy-path.welcome-text' | translate">
  </app-talent-happy-path-header>
  <div class="container-body">
    <div class="thank-you-container">
      <div class="thank-you-message">
        @if (postingInfo) {
          <h3>{{ 'talent-happy-path.job-posting-closed-page.no-longer-available' | translate }}</h3>
        } @else {
          <h3>{{ 'talent-happy-path.job-posting-closed-page.job-not-found' | translate }}</h3>
        }
        <div *ngIf="showBodyText()">{{ 'talent-happy-path.job-posting-closed-page.body' | translate }}</div>
        @if (postingInfo) {
          <app-info-container
            [headerText]="'talent-happy-path.job-posting-closed-page.join-our-talent-community'"
            [subText]="'talent-happy-path.job-posting-closed-page.join-our-talent-community-sub-text' | translate"
          ></app-info-container>
        }
      </div>
      @if (postingInfo) {
        <div class="button-container">
          <button id="go-to-myaquent" mat-flat-button class="custom-button" (click)="navigateToGeneralApplication()">
            {{ isLoggedInUser() ? ("talent-happy-path.buttons.update-profile" | translate) : ("talent-happy-path.buttons.continue-to-talent-community" | translate) }}
          </button>
          <button id="explore-jobs" mat-button class="later-button" (click)="navigateToJobBoard()">
            {{ "talent-happy-path.buttons.explore-jobs" | translate }}
          </button>
        </div>
      } @else {
        <a mat-flat-button color="primary" class="continue-button single-custom-button thank-you-button"
           [href]="jobBoardUrl">
          {{ "talent-happy-path.job-posting-closed-page.button" | translate }}
        </a>
      }
    </div>
  </div>
  <app-talent-happy-path-footer class="talent-profile-footer"></app-talent-happy-path-footer>
</div>
